module.exports = __webpack_public_path__ + "static/img/change-company-bg.d43353c2.png";